export enum ClientProfileType {
  PROMOTER = 'PROMOTER',
  VENUE = 'VENUE',
  ARTIST = 'ARTIST',
  MANAGEMENT = 'MANAGEMENT',
  AGENT = 'AGENT',
  BOOKING_AGENT = 'BOOKING_AGENT',
  TALENT_BUYER = 'TALENT_BUYER',
  MISCELLANEOUS = 'MISCELLANEOUS',
  YOOP = 'YOOP',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/client-profile-type.ts